import {
  type MemberCountryCode,
  normalizeMemberCountryCode,
} from "../location";

type ScopedChannelCountryCode = Extract<MemberCountryCode, "GB">;

export type ChannelCountryScope = "ALL" | ScopedChannelCountryCode;

type ChannelScopeRecord = {
  country_scope?: string | null;
};

type MembershipChannel = ChannelScopeRecord & {
  is_joined?: boolean | null;
};

export const CHANNEL_COUNTRY_SCOPE_OPTIONS: Array<{
  value: ChannelCountryScope;
  label: string;
  shortLabel: string;
}> = [
  { value: "GB", label: "UK (incl. Northern Ireland)", shortLabel: "UK" },
  { value: "ALL", label: "Shared across countries", shortLabel: "Shared" },
];

export const normalizeChannelCountryScope = (
  value?: string | null,
): ChannelCountryScope => {
  if (value === "GB") {
    return value;
  }

  return "ALL";
};

export const getChannelCountryScopeLabel = (
  value?: string | null,
  format: "short" | "long" = "short",
) => {
  const normalized = normalizeChannelCountryScope(value);
  const option = CHANNEL_COUNTRY_SCOPE_OPTIONS.find(
    (entry) => entry.value === normalized,
  );

  if (!option) {
    return format === "long" ? "Shared across countries" : "Shared";
  }

  return format === "long" ? option.label : option.shortLabel;
};

export const matchesChannelCountryScope = (
  channel: ChannelScopeRecord,
  memberCountryCode?: string | null,
) => {
  const scope = normalizeChannelCountryScope(channel.country_scope);
  if (scope === "ALL") {
    return true;
  }

  return scope === normalizeMemberCountryCode(memberCountryCode);
};

export const getVisibleChannelsForMember = <TChannel extends MembershipChannel>(
  channels: TChannel[],
  memberCountryCode?: string | null,
) =>
  channels.filter(
    (channel) => channel.is_joined || matchesChannelCountryScope(channel, memberCountryCode),
  );
